<template>
  <div>
    <div
      class="c-facet__search-bar mt-6"
    >
      <div class="flex items-center flex-wrap theme theme-white w-full pl-2 pr-2 py-1 rounded-lg">
        <SelectedFilters
          v-if="(selectedTags.length || store.state.searchTerms.length)"
          class="md:flex items-center flex-wrap"
        />
        <div class="flex flex-1 items-center mt-1 mb-1">
          <SearchBarAutocomplete
            class="hidden md:block flex-grow"
            :model="model"
            :is-facet-page="isFacetPage"
          />
          <SearchBarAutocompleteMobile
            class="md:hidden"
            :model="model"
          />
          <span
            v-if="selectedTags.length || store.state.searchTerms.length"
            role="button"
            class="inline-flex bg-blue-dark p-2 ltr:ml-auto rtl:mr-auto mr-1 rounded-full"
            @click="clearSearchResults"
          >
            <IconCross
              width="12px"
              height="12px"
              stroke="white"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconCross from '@/assets/icons/icon-cross.svg'
import store from '@/components/facet/store'
import updateUrl from '@/components/facet/update-url'
import tracking from '@/helpers/tracking'
import SelectedFilters from '@/components/facet/FacetSelectedFilters.vue'

export default {
  components: {
    IconCross,
    SelectedFilters,
    SearchBarAutocomplete: () => import('@/components/facet/SearchBarAutocomplete.vue'),
    SearchBarAutocompleteMobile: () => import('@/components/facet/SearchBarAutocompleteMobile.vue')
  },
  props: {
    filtersButtonText: {
      type: String,
      default: ''
    },
    model: {
      type: Object,
      required: true
    },
    isFacetPage: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedTags: this.model.selectedTags,
      store
    }
  },
  watch: {
    'store.state.tags': {
      handler(tags) {
        this.selectedTags = tags
      }
    }
  },
  mounted() {
    this.setInitialTags()
    this.setInitialSearchTerms()
    this.setInitialFacetSlug()
  },
  methods: {
    setInitialTags() {
      const { selectedTags: tags } = this.model
      this.store.dispatch('setTags', { tags })
    },
    setInitialFacetSlug() {
      const { facetSlug } = this.model
      this.store.dispatch('setFacetSlug', { facetSlug })
    },
    setInitialSearchTerms() {
      const url = new URL(window.location.href)
      const searchParams = new URLSearchParams(url.search.slice(1))
      const searchTerms = searchParams.get('search')
      if (searchTerms) {
        this.store.dispatch('setSearchTerms', { searchTerms: searchTerms.split('+') })
      }
    },
    async clearSearchResults() {
      tracking.removeAllFilters({
        store: this.store,
        placement: 'hero filters'
      })
      this.store.dispatch('showLoader')
      this.store.dispatch('resetCards')
      updateUrl.reload()
    },
    openModal() {
      this.$refs.fakeInput.focus() // fix for IOS
      this.store.dispatch('setMobileAutoCompleteVisibility', { value: true })
    },
    hideModal() {
      this.store.dispatch('setMobileAutoCompleteVisibility', { value: false })
    },
    openAllFilters() {
      this.store.dispatch('setAllFiltersVisibility', { value: true })
    }
  }
}
</script>
